export default "__VITE_ASSET__be980e85__"